// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"607":"9b09f09c","699":"3ba132ef","766":"ecc06f1f","918":"c24a822f"}[chunkId] + ".css";
};